import { render, staticRenderFns } from "./Order1.vue?vue&type=template&id=422acef5&scoped=true"
import script from "./Order1.vue?vue&type=script&lang=js"
export * from "./Order1.vue?vue&type=script&lang=js"
import style0 from "./Order1.vue?vue&type=style&index=0&id=422acef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_cache-loader@4.1.0_webpack@4.47.0__css-load_736381c0260194bb481b34437055cd65/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422acef5",
  null
  
)

export default component.exports